import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, Home, FileText, ShieldCheck, Settings } from "lucide-react";
import { SOSButton } from "./SOSButton";

export const MemberLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const NavItem = ({ to, icon: Icon, label, testId }) => {
    const active = loc.pathname === to || (to !== "/app" && loc.pathname.startsWith(to));
    return (
      <Link
        to={to}
        data-testid={testId}
        className={`flex flex-col items-center justify-center gap-1 rounded-md px-3 py-2 text-xs font-medium transition-opacity ${
          active ? "text-white opacity-100" : "text-white/60 opacity-90 hover:opacity-100"
        }`}
      >
        <Icon className="h-5 w-5" />
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-30 border-b border-border bg-background/95 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="rounded-md p-1.5" style={{ background: "hsl(var(--haruki-leaf))" }}>
              <ShieldCheck className="h-4 w-4 text-white" />
            </div>
            <div>
              <div className="font-heading text-base font-semibold leading-none">Haruki Health</div>
              <div className="mt-1 text-[10px] uppercase tracking-widest text-muted-foreground">
                Resilience Training
              </div>
            </div>
          </div>
          <button
            data-testid="member-logout-button"
            onClick={async () => { await logout(); nav("/"); }}
            className="rounded-md p-2 text-muted-foreground transition-opacity hover:opacity-80"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-6 pb-28">
        {children}
      </main>

      <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-border bg-background/95 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-around px-4 py-2">
          <NavItem to="/app" icon={Home} label="Modules" testId="nav-modules" />
          <NavItem to="/app/history" icon={FileText} label="History" testId="nav-history" />
          <NavItem to="/app/certificates" icon={FileText} label="Certificates" testId="nav-certificates" />
          <NavItem to="/app/settings" icon={Settings} label="Account" testId="nav-settings" />
        </div>
      </nav>

      {/* SOS is excluded for trial users (paid plans only) */}
      {user?.can_use_sos !== false && <SOSButton />}
    </div>
  );
};

export default MemberLayout;
